import { Button, Input } from 'react-native-elements';
import { Controller, useForm } from 'react-hook-form';
import { MainContext, api } from '../../../App.context';
import { View, useWindowDimensions } from 'react-native';
import { MaskedTextInput } from 'react-native-mask-text';
import React from 'react';
import { ScrollableScreenLayout } from '../../common/ui/components/screen-layout.component';
import i18n from 'i18n-js';
import { isWeb } from '../../common/utils/platform.utils';
import theme from '../../common/ui/theme';
import { useRoute } from '@react-navigation/native';
import { useToast } from 'react-native-toast-notifications';
import { webViewDesignSupport } from '../../common/utils/secure-store.utils';
import { useAppDispatch } from '../../hooks/store';
import { profileState } from '../../store/auth0/slice';

export const EditPhoneScreen = () => {
    const { width, height } = useWindowDimensions();
    const {
        params: { profile },
    } = useRoute();

    const {
        control,
        handleSubmit,
        formState: { isValid, errors },
    } = useForm();
    const toast = useToast();

    const focusInput = true;
    const dispatch = useAppDispatch();

    const onSubmit = (formData) => {
        toast.hideAll();
        // convert `+1 xxx-YYY-zzzz` to `+1xxxYYYzzzz`
        const phoneNumber = formData.phone_number.replace(/[- ]/g, '');
        const body = {
            phone_number: phoneNumber,
        };

        return api
            .patch('/customer', { body })
            .then((response) => {
                 dispatch(profileState(response))
                toast.show(
                    i18n.t('pages.profile.editPhoneNumber.toast.success'),
                    {
                        type: 'successWithTitle',
                    }
                );
            })
            .catch((err) => {
                toast.show(err.message, {
                    type: 'dangerWithTitle',
                    data: {
                        title: i18n.t('common.errorTitle'),
                    },
                });
            });
    };

    return (
        <ScrollableScreenLayout>
            <View style={{ flex: 1 }}>
                <Controller
                    control={control}
                    name="phone_number"
                    rules={{
                        required: {
                            value: 'true',
                            message: i18n.t('forms.common.required'),
                        },
                        pattern: {
                            value: /^\+1\s[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
                            message: i18n.t('forms.phoneNumber.invalidFormat'),
                        },
                    }}
                    render={({ field: { onChange, onBlur, value } }) => (
                        <Input
                            InputComponent={MaskedTextInput}
                            mask="+1 999-999-9999"
                            errorMessage={
                                focusInput &&
                                errors.phone_number &&
                                errors.phone_number.message
                            }
                            errorStyle={
                                theme.ReactNativeElementsTheme.Input.errorStyle
                            }
                            keyboardType="phone-pad"
                            label={i18n.t('forms.phoneNumber.label')}
                            placeholder={i18n.t(
                                'forms.phoneNumber.placeholder'
                            )}
                            onChangeText={onChange}
                            onBlur={onBlur}
                            value={value}
                            style={webViewDesignSupport}
                            autoFocus={true}
                            defaultValue={profile.phone_number}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name="mobile_number"
                    // rules={{
                    //     required: {
                    //         value: 'true',
                    //         message: i18n.t('forms.common.required'),
                    //     },
                    //     pattern: {
                    //         value: /^\+1\s[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
                    //         message: i18n.t('forms.mobileNumber.invalidFormat'),
                    //     },
                    // }}
                    render={({ field: { onChange, onBlur, value } }) => (
                        <Input
                            InputComponent={MaskedTextInput}
                            mask="+1 999-999-9999"
                            errorMessage={
                                focusInput &&
                                errors.mobile_number &&
                                errors.mobile_number.message
                            }
                            errorStyle={
                                theme.ReactNativeElementsTheme.Input.errorStyle
                            }
                            keyboardType="phone-pad"
                            label={i18n.t('forms.mobileNumber.label')}
                            placeholder={i18n.t(
                                'forms.mobileNumber.placeholder'
                            )}
                            onChangeText={onChange}
                            onBlur={onBlur}
                            value={value}
                            style={webViewDesignSupport}
                            autoFocus={true}
                            defaultValue={profile.mobile_number}
                        />
                    )}
                />
                <View
                    style={isWeb() ? {
                        bottom: 20,
                        position: 'fixed',
                        width: width - 50,
                    } : null
                    }
                >
                    <Button
                        buttonStyle={theme.styles.buttonStylePrimary}
                        titleStyle={theme.styles.titleStylePrimary}
                        disabled={!isValid}
                        title={i18n.t('forms.common.save')}
                        onPress={handleSubmit(onSubmit)}
                    />
                </View>
            </View>
        </ScrollableScreenLayout>
    );
};
